import BannerComponent from "../components/banner/BannerComponent";
import * as React from "react";

export type PageType = "searchPage" | "categoryPage" | "homePage" | "storelistPage";
export type BannerType = "heroBanner" | "articlesTilesTeaser" | "halfPageBanner" | "fullPageBanner" | "tileBanner";
type CustomerType = "anon" | "nonFsd" | "fsd";
export type TargetParams = {
    categoryId?: string;
    categoryPathId?: Array<string>;
    customerTargetGroup?: string;
    customerCategoryGroup?: string;
    customerType?: CustomerType;
    storelistId?: string;
    isCarouselMember?: boolean;
};

/**
 * the key is the breaking point for the device
 * the value is the Image url
 */
export type ResponsiveImages = {
    [key: string]: string;
};

const getOneBanner = (page: PageType, type: BannerType, targetParams?: TargetParams, onBannerLoaded?: () => void) => {
    return (
        <BannerComponent
            pageType={page}
            bannerType={type}
            targetParams={targetParams}
            onBannerLoaded={onBannerLoaded}
        />
    );
};

const exported = {
    getOneBanner
};

export default exported;
export { getOneBanner };
